import { render, staticRenderFns } from "./ContentFeedPreview.vue?vue&type=template&id=4527912e&scoped=true"
import script from "./ContentFeedPreview.vue?vue&type=script&lang=js"
export * from "./ContentFeedPreview.vue?vue&type=script&lang=js"
import style0 from "./ContentFeedPreview.vue?vue&type=style&index=0&id=4527912e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527912e",
  null
  
)

export default component.exports